import { __rest } from "tslib";
import React from 'react';
export default function SpinnerIcon(props) {
    const { changeHue } = props, rest = __rest(props, ["changeHue"]);
    return (React.createElement("svg", Object.assign({ viewBox: '-25 -25 50 50' }, rest),
        changeHue && (React.createElement("defs", null,
            React.createElement("filter", { id: 'hueShift' },
                React.createElement("feColorMatrix", { type: 'hueRotate', values: '-15' },
                    React.createElement("animate", { attributeName: 'values', values: '0;15;0;-15;0', dur: '5.15s', repeatCount: 'indefinite' }))))),
        React.createElement("circle", { className: 'path', cx: '0', cy: '0', r: '20', fill: 'none', strokeWidth: '4', filter: changeHue ? 'url(#hueShift)' : 'none' })));
}
//# sourceMappingURL=Spinner.svg.js.map